export const categoriesHeaderContent = {
  title: "%Confira nossos conveniados%",
  subtitle:
    "Abaixo você pode filtrar nossos conveniados por suas respectivas categorias, e buscar pelo que mais lhe interessa.",
};
